import { render, staticRenderFns } from "./forgetPassword.vue?vue&type=template&id=5d1db354"
import script from "./forgetPassword.vue?vue&type=script&lang=js"
export * from "./forgetPassword.vue?vue&type=script&lang=js"
import style0 from "./forgetPassword.vue?vue&type=style&index=0&id=5d1db354&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports